/* unplugin-vue-components disabled */import { render } from "./IHeader.vue?vue&type=template&id=5ef8cb14&scoped=true"
import script from "./IHeader.vue?vue&type=script&lang=js"
export * from "./IHeader.vue?vue&type=script&lang=js"

import "./IHeader.vue?vue&type=style&index=0&id=5ef8cb14&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef8cb14"]])

export default __exports__